
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more/login",
      function () {
        return require("private-next-pages/more/login.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/more/login"])
      });
    }
  